import React from 'react';

interface ScoreBarProps {
  score: number;
  maxScore?: number;
  label?: string;
  showPercentage?: boolean;
  className?: string;
}

const ScoreBar: React.FC<ScoreBarProps> = ({
  score,
  maxScore = 1,
  label,
  showPercentage = false,
  className = '',
}) => {
  const percentage = Math.min((score / maxScore) * 100, 100);
  const getColorClass = () => {
    if (percentage >= 80) return 'bg-green-500';
    if (percentage >= 60) return 'bg-blue-500';
    if (percentage >= 40) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {label && (
        <span className="text-sm font-medium text-gray-700 min-w-[100px]">{label}</span>
      )}
      <div className="flex-1">
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className={`h-2.5 rounded-full transition-all duration-300 ${getColorClass()}`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
      {showPercentage && (
        <span className="text-sm font-medium text-gray-600 min-w-[60px] text-right">
          {percentage.toFixed(1)}%
        </span>
      )}
      {!showPercentage && (
        <span className="text-sm font-medium text-gray-600 min-w-[60px] text-right">
          {score.toFixed(2)}/{maxScore}
        </span>
      )}
    </div>
  );
};

export default ScoreBar;
